export default function () {
  function r() {
    const s = document.createElement('script');
    s.async = 1;
    // s.type = 'text/javascript';
    s.src = '//code.tidio.co/rdpju7puk94lptucuaeoejpmle1bkroo.js';
    (document.body || document.head).appendChild(s);
  }
  if (window.attachEvent) {
    window.attachEvent('onload', r);
  } else {
    window.addEventListener('load', r, false);
  }
}
